import { OnDestroy, ViewEncapsulation, ViewChild, HostListener } from '@angular/core';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, animate, transition, style, keyframes } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../././shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../././shared/base.component';
import { LoaderService } from '.././shared/loader.service';
import { DatePipe } from '@angular/common';
import { ReceivedSmsService } from './received-sms.service'
import { SmsLogReceived } from '../work-order/work-order-models';
import { GlobalInfo, FPMessage, Severities, RoleAccess } from '.././shared/shared.model';
//import { TechSmsEnity } from '../insight/queues/tech-screening-queue.model';
@Component({
    selector: 'sms-notification',
    templateUrl: 'sms-notification.component.html',
    animations: [
        trigger('isVisibleChanged', [
            transition('void => *', [
                animate(900, keyframes([
                    style({ opacity: 0, transform: 'translateY(-200px)', offset: 0 }),
                    style({ opacity: 1, transform: 'translateY(25px)', offset: .75 }),
                    style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
                ]))
            ])
        ])
    ]
})
export class SMSNotification extends BaseComponent implements OnInit {
    @Output() done = new EventEmitter();
    @Output() open = new EventEmitter();
    @Input() smsmsg: SmsLogReceived;
    smslogReceived: SmsLogReceived[] = [];
    IsNotification: boolean = false;
    message: FPMessage;
    readnotification: string;
    boolflag: boolean;
    enablespan: boolean;
    isopenflag: boolean = false;
    smsmsvalue: any;
    CompanyId: number;
    showviewEmail: boolean = false;
    isVisible: boolean = true;
    // LogId:number;
    constructor(protected sharedService: SharedService, protected translate: TranslateService,
        protected receivedsmsService: ReceivedSmsService, private datePipe: DatePipe, private route: ActivatedRoute,
        private router: Router, private loaderservice: LoaderService) {
        super(sharedService, translate);

    }
    ngOnInit() {
        debugger;


        if (this.smsmsg.Notification == 1) {
            this.smsmsvalue = this.smsmsg;
        }

        else {
            debugger;
            this.smsmsg.ToNumber = this.smsmsg.FromNumber;
            this.smsmsvalue = this.smsmsg;

        }




        this.IsNotification = false;
        if (this.smsmsg.contenttype != null) {
            this.boolflag = this.smsmsg.contenttype.includes("video")
        }

        if (this.boolflag == true) {
            this.enablespan = true;
        }
        else {
            this.enablespan = false;
        }
        this.readnotification = this.translate.instant('Read Notification');
    }
    close(success?: boolean) {
        debugger;
        this.isopenflag = false;
        this.done.emit(success);

    }
    openNotification(success?: boolean) {

        this.open.emit(success);
    }

    smspopup() {
        debugger;

        //     var technician=this.technician;
        //     var techid=this.techid;
        //    var jobid=this.jobid;
        //   var jProjectId=this.jProjectId;
        //   var timezoneid=this.timezoneid;
        //    var schdate=this.schdate;
        //    var loginid=this.loginid;
        //    var custaddress=this.custaddress
        this.isopenflag = true;
        this.CompanyId = this.globalInfo().CompanyId;


    }
    save() {
        debugger;
        this.smsmsg.IsRead = 1;
        //  this.smsmsg.Notification=1;
        this.receivedsmsService.insert(this.smsmsg).subscribe(resp => {
            this.message = resp.Message;
            if (resp.Message.Severity == Severities.success) {

                this.close(false);
            }
            else {
                this.close(false);
            }

        }
        );
    }

    showEmailJob() {
        debugger;

        this.showviewEmail = true;
        // this.LogId=256;
    }

    CloseEmail() {
        debugger;
        this.showviewEmail = false;
    }


}